import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler } from '@angular/common/http';
import { cookieExists, getCookieValue } from './cookies.service';

const COOKIE_KEY = 'testAutodata';

@Injectable()
export class TestAutomationInterceptor implements HttpInterceptor {
  public intercept(req: HttpRequest<any>, next: HttpHandler) {
    if (!cookieExists(COOKIE_KEY)) {
      return next.handle(req);
    }

    const cookieValue = getCookieValue(COOKIE_KEY),
     headers = req.headers.set(COOKIE_KEY, cookieValue);

    return next.handle(req.clone({
      headers
    }));
  }
}
